import React, { useState, useEffect, useRef } from 'react';
import { SVG } from '@svgdotjs/svg.js';

const Contrapisos = () => 
{
  const canvasRef = useRef(null);
  const b = 1;  
  const [h, setH] = useState(0.10); // Altura de la Losa en metros
  const [selectedLayer, setSelectedLayer] = useState('inferiorZ');
  const [zoom, setZoom] = useState(1);
  const [padding, setPadding] = useState(50); //Recubrimiento en mm
  const [ladoLargo, setLadoLargo] = useState('Z');
  const [MuX, setMuX] = useState();
  const [MuZ, setMuZ] = useState();

  const [PP, setPP] = useState();
  const [CM, setCM] = useState(300);
  const [CV, setCV] = useState(100);

  const canvasSize = 1000;

  // Capas de refuerzo
  const [layers, setLayers] = useState({
    inferiorX: { numBars: 4, barDiameter: 10 },
    inferiorZ: { numBars: 5, barDiameter: 16 },
  });

  const barOptions = [8, 10, 12, 14, 16, 18, 20, 22, 25, 28, 32, 36]; // Diámetros en mm

  // Función de zoom
  const handleZoom = (event) => 
  {
    event.preventDefault();
    const delta = event.deltaY > 0 ? 0.9 : 1.1;
    setZoom((prevZoom) => Math.min(Math.max(prevZoom * delta, 0.5), 3));
  };

  // Cálculo de refuerzo intermedio
  useEffect(() => 
  {
    const maxDist = 0.6; // Distanciamiento máximo en metros
    setLayers((prevLayers) => ({
      ...prevLayers,
      intermedio: h > maxDist
        ? { numBars: 2, barDiameter: 12 }
        : { numBars: 0, barDiameter: 0 }
    }));
  }, [h]);

  //Dibujar
  useEffect(() => 
  {
    canvasRef.current.innerHTML = '';

    const draw = SVG().addTo(canvasRef.current).size('100%', '100%').viewbox(0, 0, canvasSize, canvasSize);
    const scale = canvasSize * zoom;

    const beamWidth = b * scale  ;
    const beamHeight = h * scale;
    const centerX = (canvasSize - beamWidth) / 2;
    const centerY = (canvasSize - beamHeight) / 2;

    // Dibujar la Losa Corte Eje X
    draw
      .rect(beamWidth, beamHeight)
      .fill('#e2e8f0')
      .stroke({ color: '#2d3748', width: 1 })
      .move(centerX, centerY);   

    const drawReforcement = () => 
    {
      const numBarsX = layers["inferiorX"].numBars;
      const barDiameterX = layers["inferiorX"].barDiameter;

      const numBarsZ = layers["inferiorZ"].numBars;
      const barDiameterZ = layers["inferiorZ"].barDiameter;

      const effectiveWidth = beamWidth - 2 * padding - barDiameterZ; // Consideramos el recubrimiento
      const barSpacing = Number(numBarsZ > 1 ? effectiveWidth / (numBarsZ - 1) : 0).toFixed(2); // Evitar división por 0 si hay solo 1 varilla

      for (let i = 0; i < numBarsZ; i++) 
      {
        draw
          .circle(barDiameterZ)
          .fill(selectedLayer === "inferiorZ" ? '#dc2626' : '#2d3748')
          .move(
            (canvasSize/2 + padding + i * barSpacing) - (beamWidth/2),
            (canvasSize/2 + beamHeight - padding - barDiameterZ) - (beamHeight/2) - (ladoLargo === 'X' ? barDiameterX : 0)
          )
          .click(() => setSelectedLayer("inferiorZ"));
      }

      draw
        .line(canvasSize/2 - beamWidth/2, centerY + beamHeight - padding - (ladoLargo === 'Z' ? barDiameterZ + barDiameterX/2 : barDiameterX/2), canvasSize/2 + beamWidth/2, centerY + beamHeight - padding - (ladoLargo === 'Z' ? barDiameterZ + barDiameterX/2 : barDiameterX/2))
        .stroke({ color: selectedLayer === "inferiorX" ? '#dc2626' : '#2d3748', width: barDiameterX })
        .click(() => setSelectedLayer("inferiorX"));
    };
  
    drawReforcement();
    slabThickness();

    calculatedPP(b,h)

  }, [b, h, layers, selectedLayer, zoom, padding, ladoLargo]);

  // Función para calcular el área de refuerzo con número de barras y diámetro en mm
  const calculatedPP = (b, h) => 
  {
    setPP(Number(b * b * h * 2400).toFixed(0)); 
  };

  const slabThickness = () => 
  {
    const fc = 210; // kg/cm2
    const cargaTotal = Number(PP) + Number(CM) + Number(CV);

    console.log(cargaTotal);

    const t = Math.pow(cargaTotal/ (fc * 10000), .5);
    console.log(t * 100);
  };  

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Canvas para el dibujo */}
      <div
        className="w-5/6 flex items-center justify-center"
        onWheel={handleZoom}
      >
        <div
          ref={canvasRef}
          className="bg-white shadow w-full h-[100vh] overflow-hidden"
        ></div>
      </div>

      {/* Menú de configuración */}
      <div className="w-1/6 max-h-1/2 p-4 bg-white shadow rounded-lg">
        <h2 className="text-xl font-bold mb-4">Configuración</h2>
        <div className="mb-4">
          <label className="block text-gray-700">Ancho Losa (b) [m]:</label>
          <input
            type="number"
            step="0.05"
            min="0.15"
            max="1"
            value={b}
            disabled
            className="w-full border rounded p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Altura de la Losa (h) [m]:</label>
          <input
            type="number"
            step="0.01"
            min="0.05"
            max="0.20"
            value={h}
            onChange={(e) => 
              {
                const value = Number(e.target.value);
                const min = 0.05;
                const max = 0.20;
          
                if (isNaN(value) || value < min || value > max) {
                  alert(`Ingrese un valor entre ${min} y ${max} metros`);
                  return;
                }
          
                setH(value);
              }}
            className="w-full border rounded p-2"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Recubrimiento [cm]:</label>
          <input
            type="number"
            step="1"
            min="5"
            max="10"
            value={padding/10}

            onChange={(e) => 
              {
                const value = Number(e.target.value);
                const min = 5;
                const max = 10;
          
                if (isNaN(value) || value < min || value > max) {
                  alert(`Ingrese un valor entre ${min} y ${max} cm`);
                  return;
                }
          
                setPadding(parseFloat(value * 10))                
              }}
            className="w-full border rounded p-2"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Seleccionar Malla Electrosoldada:</label>
          <input
            type="number"
            min="3"
            max="10"
            value={layers[selectedLayer].numBars}
            onChange={(e) => 
              {
                const value = Number(e.target.value);
                const min = 3;
                const max = 10;
          
                if (isNaN(value) || value < min || value > max) 
                {
                  alert(`Ingrese un valor entre ${min} y ${max} varillas`);
                  return;
                }                       
          
                setLayers((prev) => ({
                  ...prev,
                  [selectedLayer]: { ...prev[selectedLayer], numBars: parseInt(value) }
                }))
              }}
            className="w-full border rounded p-2"
          />
          <label className="block text-gray-700">1∅{layers[selectedLayer].barDiameter}@{Number(100/(layers[selectedLayer].numBars - 1)).toFixed(2)}cm</label>
        </div>

        <h3 className="text-xl font-bold mb-4">Cargas</h3>

        <div className="mb-4">
          <label className="block text-gray-700">Peso Propio [kg/m²]:</label>
          <input
            type="number"
            step="10"
            min="50"
            max="1000"
            value={PP}
            disabled
           
            className="w-full border rounded p-2"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Carga Muerta [kg/m²]:</label>
          <input
            type="number"
            step="10"
            min="50"
            max="1000"
            value={CM}

            onChange={(e) => 
              {
                const value = Number(e.target.value);
                const min = 50;
                const max = 1000;
          
                if (isNaN(value) || value < min || value > max) {
                  alert(`Ingrese un valor entre ${min} y ${max} kg/m²`);
                  return;
                }
          
                setCM(parseFloat(value))
              }}
            className="w-full border rounded p-2"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Carga Viva [kg/m²]:</label>
          <input
            type="number"
            step="10"
            min="50"
            max="1000"
            value={CV}

            onChange={(e) => 
              {
                const value = Number(e.target.value);
                const min = 50;
                const max = 1000;
          
                if (isNaN(value) || value < min || value > max) {
                  alert(`Ingrese un valor entre ${min} y ${max} kg/m²`);
                  return;
                }
          
                setCV(parseFloat(value))
              }}
            className="w-full border rounded p-2"
          />
        </div>
        
              

      </div>      
    </div>
  );
};

export default Contrapisos;